export const TENANT_ID_TOKEN_KEY = "tenant_id_token";
const LEGACY_TENANT_TOKEN_KEY = "sami_api_studio_token";
const SESSION_TOKEN_KEY = "sami_session_token";
const ID_TOKEN_KEY = "sami_id_token";
const REFRESH_TOKEN_KEY = "sami_refresh_token";

let token: string | null = null;
let sessionToken: string | null = null;
let idToken: string | null = null;
let refreshToken: string | null = null;

function readTenantTokenFromStorage(): string | null {
  const current = localStorage.getItem(TENANT_ID_TOKEN_KEY);
  if (current) return current;

  const legacy = localStorage.getItem(LEGACY_TENANT_TOKEN_KEY);
  if (legacy) {
    localStorage.setItem(TENANT_ID_TOKEN_KEY, legacy);
    localStorage.removeItem(LEGACY_TENANT_TOKEN_KEY);
    return legacy;
  }

  return null;
}

export function getToken(): string | null {
  if (token) return token;
  token = readTenantTokenFromStorage();
  return token;
}

export function setToken(value: string | null): void {
  token = value;
  if (value) {
    localStorage.setItem(TENANT_ID_TOKEN_KEY, value);
    localStorage.removeItem(LEGACY_TENANT_TOKEN_KEY);
  } else {
    localStorage.removeItem(TENANT_ID_TOKEN_KEY);
    localStorage.removeItem(LEGACY_TENANT_TOKEN_KEY);
  }
}

export function getSessionToken(): string | null {
  if (sessionToken) return sessionToken;
  sessionToken = localStorage.getItem(SESSION_TOKEN_KEY) || null;
  return sessionToken;
}

export function setSessionToken(value: string | null): void {
  sessionToken = value;
  if (value) {
    localStorage.setItem(SESSION_TOKEN_KEY, value);
  } else {
    localStorage.removeItem(SESSION_TOKEN_KEY);
  }
}

export function getIdToken(): string | null {
  if (idToken) return idToken;
  idToken = localStorage.getItem(ID_TOKEN_KEY) || null;
  return idToken;
}

/**
 * Bearer for CMS /auth/my-tenants and /auth/tenant-jwt.
 * Prefers Cognito ID token when present; falls back to session token (dev JWT or access token).
 */
export function getCmsIdentityToken(): string | null {
  return getIdToken() ?? getSessionToken();
}

export function setIdToken(value: string | null): void {
  idToken = value;
  if (value) {
    localStorage.setItem(ID_TOKEN_KEY, value);
  } else {
    localStorage.removeItem(ID_TOKEN_KEY);
  }
}

export function getRefreshToken(): string | null {
  if (refreshToken) return refreshToken;
  refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY) || null;
  return refreshToken;
}

export function setRefreshToken(value: string | null): void {
  refreshToken = value;
  if (value) {
    localStorage.setItem(REFRESH_TOKEN_KEY, value);
  } else {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }
}

export function clearAuthTokens(): void {
  setToken(null);
  setSessionToken(null);
  setIdToken(null);
  setRefreshToken(null);
}
